import { render, staticRenderFns } from "./DeleteDnsIcon.vue?vue&type=template&id=58a6c29c&"
import script from "./DeleteDnsIcon.vue?vue&type=script&lang=js&"
export * from "./DeleteDnsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports